import Pretender from 'pretender';

import segmentPretender from './segment';
import feDataPretender from './fe-data';
import personaDatePretender from '../redux/persona/pretender';
import servicesDataPretender from './services';
import contactMethodsPretender from './contactMethods';
import incidentsPretender from './incidents';

export const init = () => {
  const server = new Pretender(
    feDataPretender,
    segmentPretender,
    personaDatePretender,
    servicesDataPretender,
    contactMethodsPretender,
    incidentsPretender,
  );

  server.handledRequest = function handledRequest(verb, path, request) {
    console.info(`[Pretender] ${verb} ${path}`, request);
  };
};

export default init;
